<template>
  <Button
    :disabled="disable"
    :type="type || 'primary'"
    :size="size || 'large'"
    @click="clickBtn"
    >{{ text }}</Button
  >
</template>

<script>
import { jump } from '@/common';
import { elementClick } from '@/utils/track/baidu_statistics';

export default {
  props: ['url', 'text', 'disable', 'size', 'type'],
  methods: {
    clickBtn() {
      elementClick(this.text);
      if (!this.url) return;
      jump(this.url);
    }
  }
};
</script>
